import { render, staticRenderFns } from "./CardSite.vue?vue&type=template&id=abbb88b0&scoped=true"
import script from "./CardSite.vue?vue&type=script&lang=js"
export * from "./CardSite.vue?vue&type=script&lang=js"
import style0 from "./CardSite.vue?vue&type=style&index=0&id=abbb88b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbb88b0",
  null
  
)

export default component.exports